<!-- <mat-tab-group fxFlex="0 0 100%" class="liquitics-box" [(selectedIndex)]="selectedTabIndex" (selectChange)="tabSelectChange($event)" [@.disabled]="true"> -->
<!-- <mat-tab> -->
<!-- <ng-template mat-tab-label>
            <span class="fa fa-sort-amount-asc"></span>
            <span>Explain</span>
        </ng-template> -->
<app-explain *ngIf="selectedTabIndex === 0" [explainMode]="'BY_SOURCE'" fxFlex="0 0 100%"></app-explain>
<!-- </mat-tab> -->
<!-- <mat-tab fxLayout="column"> -->
<!-- <ng-template mat-tab-label>
            <span class="fa fa-clock-o"></span>
            <span>Histo Analysis</span>
        </ng-template> -->
<app-histo *ngIf="selectedTabIndex === 1" fxFlex="0 0 100%"></app-histo>
<!-- </mat-tab> -->
<!-- <mat-tab fxLayout="column"> -->
<!-- <ng-template mat-tab-label>
            <span class="fa fa-bell-o"></span>
            <span>Alerts</span>
        </ng-template> -->
<app-alert class="detail-content" *ngIf="selectedTabIndex === 2" fxFlex="0 0 100%"></app-alert>

<app-foreign-outflow-details *ngIf="selectedTabIndex === 3" fxFlex="0 0 100%"></app-foreign-outflow-details>

<!-- <app-intraday-ladder *ngIf="selectedTabIndex === 4" fxFlex="0 0 100%"></app-intraday-ladder> -->
<app-throughput *ngIf="selectedTabIndex === 4" fxFlex="0 0 100%"></app-throughput>
<app-multi-entity-nostro-details *ngIf="selectedTabIndex === 5" fxFlex="0 0 100%"></app-multi-entity-nostro-details>
<app-suspense-balance-details *ngIf="selectedTabIndex === 6" fxFlex="0 0 100%"></app-suspense-balance-details>
<!-- </mat-tab> -->
<!-- </mat-tab-group> -->